import { render, staticRenderFns } from "./WebFoot.vue?vue&type=template&id=58a8ecfa&"
import script from "./WebFoot.vue?vue&type=script&lang=js&"
export * from "./WebFoot.vue?vue&type=script&lang=js&"
import style0 from "./WebFoot.vue?vue&type=style&index=0&id=58a8ecfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports